import { Button } from '../../../../../core'
import { useHasUserCapability } from '../../../../hooks/useHasUserCapability'
import { useCurrentUser } from '../../../../utils/currentUserContext'
import { useUpdateEncounterMutation } from '../../hooks/useEncounterMutations'
import type { components } from '@joyful/openapi/types.gen'
export interface EncounterSnoozeAcknowledgementButtonProps {
  encounter: Pick<
    components['schemas']['EncounterListItem'],
    'id' | 'assignee_biller_user_id'
  >
}

export function EncounterSnoozeAcknowledgementButton({
  encounter,
}: EncounterSnoozeAcknowledgementButtonProps) {
  const currentUser = useCurrentUser()
  const canAcknowledgeAnyEncounter = useHasUserCapability(
    'encounter.action.snooze.acknowledge',
  )
  const updateEncounter = useUpdateEncounterMutation()
  const isBillerAssignee = encounter.assignee_biller_user_id === currentUser.id

  if (isBillerAssignee === false && canAcknowledgeAnyEncounter === false) {
    return null
  }

  return (
    <Button
      onClick={() => {
        updateEncounter.mutate({
          encounterId: encounter.id,
          snoozed_until: null, // Setting to null acknowledges the expired snooze
        })
      }}
      isPending={updateEncounter.isPending}
      disabled={updateEncounter.isPending}
      size="sm"
      variant="ghost"
    >
      Acknowledge
    </Button>
  )
}
